<span class="hd-property-tile__icon" aria-hidden="true">
  <i [class]="'fad fa-' + icon()"></i>
</span>
<div class="hd-property-tile__body">
  <div class="hd-property-tile__head">
    <span class="hd-property-tile__label">{{ label() }}</span>
    <ng-content select="[tileAction]" />
  </div>
  <div class="hd-property-tile__value">
    <ng-content />
  </div>
</div>
<ng-content select="[tileFooter]" />
